import React from "react";
import i18next from "i18next";
import { WmsInput } from "./WmsInput";
import { WmsLayers } from "./WmsLayers";
import { AccordionItem } from "../../Elements/Accordion";
import { useMapContext } from "../../Contexts/MapContext";
import "./WmsAddition.scss";

export const WmsAddition = (): JSX.Element => {
    const { wmsState } = useMapContext();
    return (
        <AccordionItem title={i18next.t("addWms.wmsLayers")} changeHeight={Date.now()} key="addWms">
            <WmsInput />
            {wmsState.length ? <WmsLayers /> : null}
        </AccordionItem>
    );
};
